import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './config/permission'
import './utils/qrcode'
import './plugins'
import './plugins/sentry'
import './styles/index.scss'
import i18n from './locale/index'
import { projectName } from '@/config'
import '@wangeditor/editor/dist/css/style.css'
import { Boot } from '@wangeditor/editor'
import attachmentModule from '@wangeditor/plugin-upload-attachment'

LocalForage.config({
  name: projectName,
  storeName: 'dataStore',
  description: `${projectName}本地存储数据库`,
})
Boot.registerModule(attachmentModule)
Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
